import { useComponentState } from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { Alert, Badge, Button, Col, Form, Row } from "react-bootstrap";
import CartAddress from "src/components/CartAddress";
import CartAddressForm from "src/components/CartAddressForm";
import CartItem from "src/components/CartItem";
import Content from "src/components/Content";
import Coupon from "src/components/Coupon";
import EmptyBasket from "src/components/EmptyBasket";
import Footer from "src/components/Footer";
import Footers from "src/components/Footers";
import GiftSection from "src/components/GiftSection";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import Heading from "src/components/Heading";
import Page from "src/components/Page";
import PayuForm from "src/components/PayuForm";
import Preloader from "src/components/Preloader";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getCookieByName from "src/functions/getCookieByName";
import getDefaultOg from "src/functions/getDefaultOg";
import gutter from "src/functions/gutter";
import validateAuthToken from "src/functions/validateAuthToken";
import { sAlert } from "src/styles/sAlert.module.scss";
import { sBadge } from "src/styles/sBadge.module.scss";
import { sButton } from "src/styles/sButton.module.scss";
import { sCartSubmit } from "src/styles/sCartSubmit.module.scss";
import { sCartSummary } from "src/styles/sCartSummary.module.scss";
import { sPageCart } from "src/styles/sPageCart.module.scss";
import { VariantColor } from "src/types/VariantColor";

function Cart({ ["static"]: _static, ...Props }) {
  const { locale: lang, query } = useRouter();
  var [changeAddress, setChangeAddress] = useState(false);
  var [useAddress, setUseAddress] = useState<boolean>();
  var [isClient, setIsClient] = useState<boolean>();
  const [emptyBasket, setEmptyBasket] = useState(null);
  var [showItem, setShowItem] = useState(true);
  var [formSave, setFormSave] = useState<boolean>();
  var [showBuyBtn, setShowBuyBtn] = useState(true);
  var [fillName, setFillName] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertMessageStatus, setAlertMessageStatus] = useState<VariantColor>();

  var userData = useComponentState({
    userId: 0,
    name: "",
    surname: "",
    email: "",
    phone: "",
    street: "",
    city: "",
    zip: "",
    country: "",
    isFilledName: false,
    isFilledSurname: false,
    cardNo: "",
    password: "",
    passwordAgain: "",
  });

  const [dOrder, setDorder] = useState(null);

  useEffect(() => {
    let paymentFailed =
      window.location.href.indexOf("payment-failed") > -1 ? true : false;
    if (paymentFailed) {
      setAlertMessage(
        "Payment was not completed successfully - please try again."
      );
      setAlertMessageStatus("danger");
    }
  }, []);

  useEffect(() => {
    const cookieOrderId = getCookieByName(`orderId`);
    const cookieAuthToken = getCookieByName(`auth-token`);

    if (cookieAuthToken || cookieOrderId) {
      fetch(
        `${constants.Paths.apiUrl}/orders/${
          cookieOrderId ? cookieOrderId : "current"
        }`,
        {
          method: "GET",
          headers: validateAuthToken(cookieAuthToken, null, true),
        }
      )
        .then((res) => {
          if (res.ok) {
            setEmptyBasket(false);
            return res.json();
          } else {
            return setEmptyBasket(true);
          }
        })
        .then((data) => {
          if (data) {
            setDorder(data);
            const client = cookieAuthToken ? data.client : null;
            if (typeof client !== "object" || client === null) {
              setIsClient(false);
            } else {
              setIsClient(true);
            }
            if (typeof client === "object" && client !== null) {
              userData.change({
                userId: client.id,
                name: client.name,
                surname: client.surname,
                email: client.user.email,
                phone: client.phone,
                street: client.address?.street,
                city: client.address?.city,
                zip: client.address?.zip,
                country: client.address?.country,
                cardNo: client.card_no,
                isFilledName:
                  typeof client.name === "string" && client.name.length !== 0
                    ? true
                    : false,
                isFilledSurname:
                  typeof client.surname === "string" &&
                  client.surname.length !== 0
                    ? true
                    : false,
                password: client.user.password,
                passwordAgain: client.user.passwordAgain,
              });
            }
            if (
              typeof client !== "object" ||
              client === null ||
              client.name === null ||
              typeof client.name !== "string" ||
              client.name.length === 0 ||
              client.surname === null ||
              typeof client.surname !== "string" ||
              client.surname.length === 0
            ) {
              setUseAddress(false);
              setChangeAddress(true);
              setShowBuyBtn(false);
              setFillName(true);
            } else {
              setUseAddress(true);
              setChangeAddress(false);
              setFormSave(false);
              setShowBuyBtn(true);
              setFillName(false);
            }
          }
          setShowItem(true);
        });
    } else {
      setEmptyBasket(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showItem, formSave]);

  const [gift, setGift] = useState(false);
  const [giftDisabled, setGiftDisabled] = useState(false);
  const [giftMessage, setGiftMessage] = useState("");

  useEffect(() => {
    setGiftDisabled(false);
    dOrder &&
      dOrder.order_items.map((item) => {
        if (
          item.entity_type !== "subscription" &&
          !(
            item.entity_type === "lecture" &&
            item.entity_id === constants.Marketing.giftCardId
          )
        ) {
          setGiftDisabled(true);
        }

        if (item.entity_id === constants.Marketing.giftCardId) {
          setGift(true);
          setGiftDisabled(true);
        }
      });
  }, [dOrder, showItem]);

  const giftCardSubmit = () => {
    fetch(`${constants.Paths.apiUrl}/payu-requests`, {
      method: "POST",
      headers: validateAuthToken(getCookieByName(`auth-token`)),
    }).then(async (res) => {
      if (res.ok) {
        const url = await res.text();
        window.location.href = url;
      } else {
        setAlertMessage(
          "Failed to redirect to the payment gateway, if the problem persists, please contact customer support."
        );
      }
    });
  };

  const productListRef = useRef(null);
  query.registered === "true" && productListRef.current?.scrollIntoView();

  return (
    <>
      <Headers data={getDefaultOg(lang)} />
      <Page className={composeClassNames([sPageCart, "page-cart"])}>
        <Header />
        {alertMessage && (
          <Alert
            variant={alertMessageStatus}
            className={composeClassNames([sAlert, "alert-flash"])}
          >
            <Translate tKey={alertMessage} />
          </Alert>
        )}
        {isClient && fillName && dOrder && dOrder.order_items.length > 0 && (
          <Alert
            variant="danger"
            className={composeClassNames([sAlert, "alert-flash"])}
          >
            <Translate tKey={`Please fill in your name and surname.`} />
          </Alert>
        )}
        {emptyBasket || dOrder ? (
          emptyBasket ? (
            <EmptyBasket />
          ) : dOrder ? (
            dOrder.order_items.length > 0 ? (
              <Content fluid={`xl`}>
                <Heading
                  type="h1"
                  className="text-center"
                  title={<Translate tKey={`Shopping cart`} />}
                />
                <Form>
                  {!showBuyBtn && (
                    <Row className="justify-content-md-center">
                      <Col md={10} lg={8}>
                        <Heading
                          type="h3"
                          title={<Translate tKey={`List of gems`} />}
                          className="text-center"
                          style={gutter(`margin`, `vertical`, `lg`)}
                        />
                        {/* Items */}
                        {dOrder.order_items.map((item) => {
                          if (item.order_item === null && showItem)
                            return (
                              <CartItem
                                amountTotal={item.amountTotal}
                                description={item.description}
                                descriptionNoTrial={item.description_no_trial}
                                discount={
                                  !gift && item.price_basic > item.price
                                    ? Math.round(
                                        ((item.price_basic - item.price) /
                                          item.price_basic) *
                                          100
                                      )
                                    : ""
                                }
                                itemId={item.id}
                                imgURL={item.thumbnail}
                                isClient={isClient}
                                isStream={item.isStream}
                                key={item.id}
                                orderId={dOrder.uuid}
                                period={item?.period}
                                price={gift ? item.price_basic : item.price}
                                priceBasic={
                                  !gift && item.price_basic > item.price
                                    ? item.price_basic
                                    : ""
                                }
                                setShowItem={setShowItem}
                                slug={item.slug}
                                title={item.title}
                                type={item.entity_type}
                                gift={gift}
                              />
                            );
                        })}
                        <GiftSection
                          gift={gift}
                          setGift={setGift}
                          giftMessage={giftMessage}
                          setGiftMessage={setGiftMessage}
                          giftDisabled={giftDisabled}
                        />
                      </Col>
                    </Row>
                  )}
                  {/* User data */}
                  <Row className="justify-content-md-center">
                    <Col md={6} className="text-center">
                      <Heading
                        type="h3"
                        title={<Translate tKey={`Personal informations`} />}
                        className="text-center"
                        style={gutter(`margin`, `vertical`, `lg`)}
                      />
                      {useAddress && (
                        <>
                          <CartAddress userData={dOrder.client} />
                          <Button
                            variant="outline-secondary"
                            onClick={() => {
                              setChangeAddress(true);
                              setUseAddress(false);
                            }}
                            type="button"
                            className={composeClassNames([
                              sButton,
                              "btn-cta",
                              "mb-4",
                              "mt-2",
                            ])}
                            size="sm"
                          >
                            <Translate tKey={`Change address`} />
                          </Button>
                        </>
                      )}
                      {/* Change Address */}
                      {changeAddress && (
                        <CartAddressForm
                          userData={userData}
                          setFormSave={setFormSave}
                          isClient={isClient}
                        />
                      )}
                    </Col>
                  </Row>
                  {showBuyBtn && (
                    <Row
                      className="justify-content-md-center"
                      ref={productListRef}
                    >
                      <Col md={10} lg={8}>
                        <Heading
                          type="h3"
                          title={<Translate tKey={`List of gems`} />}
                          className="text-center"
                          style={gutter(`margin`, `vertical`, `lg`)}
                        />
                        {/* Items */}
                        {dOrder.order_items.map((item) => {
                          if (item.order_item === null && showItem)
                            return (
                              <CartItem
                                amountTotal={item.amountTotal}
                                description={item.description}
                                descriptionNoTrial={item.description_no_trial}
                                discount={
                                  !gift && item.price_basic > item.price
                                    ? Math.round(
                                        ((item.price_basic - item.price) /
                                          item.price_basic) *
                                          100
                                      )
                                    : ""
                                }
                                itemId={item.id}
                                imgURL={item.thumbnail}
                                isClient={isClient}
                                isStream={item.isStream}
                                key={item.id}
                                orderId={dOrder.uuid}
                                period={item?.period}
                                price={gift ? item.price_basic : item.price}
                                priceBasic={
                                  !gift && item.price_basic > item.price
                                    ? item.price_basic
                                    : ""
                                }
                                setShowItem={setShowItem}
                                slug={item.slug}
                                title={item.title}
                                type={item.entity_type}
                                gift={gift}
                              />
                            );
                        })}
                        {dOrder.price !== 0 && (
                          <GiftSection
                            gift={gift}
                            setGift={setGift}
                            giftMessage={giftMessage}
                            setGiftMessage={setGiftMessage}
                            giftDisabled={giftDisabled}
                          />
                        )}
                        {constants.Show.saleCartCoupons &&
                          !gift &&
                          dOrder.price !== 0 && (
                            <Coupon setFormSave={setFormSave} />
                          )}
                        <div
                          className={composeClassNames([
                            sCartSummary,
                            "cart-summary",
                          ])}
                        >
                          <Heading
                            type="h3"
                            title={<Translate tKey={`Total price`} />}
                            className="text-center"
                          />
                          {dOrder.price_basic > dOrder.price &&
                          dOrder.price !== 1 &&
                          !gift ? (
                            <Badge
                              pill={true}
                              variant="primary"
                              className={composeClassNames([
                                sBadge,
                                "badge-discount",
                              ])}
                            >
                              -
                              {Math.round(
                                ((dOrder.price_basic - dOrder.price) /
                                  dOrder.price_basic) *
                                  100
                              )}
                              %
                            </Badge>
                          ) : (
                            ""
                          )}
                          <div className="prices">
                            {!gift && dOrder.price_basic > dOrder.price && (
                              <span className="price price-basic">
                                {dOrder.price_basic}
                                <Translate tKey={`CZK`} />
                              </span>
                            )}
                            <span className="price">
                              {gift ? dOrder.price_basic : dOrder.price}{" "}
                              <Translate tKey={`CZK`} />
                            </span>
                          </div>
                        </div>
                        {dOrder.price === 0 ? (
                          <div
                            className={composeClassNames([
                              sCartSubmit,
                              "cart-submit",
                            ])}
                          >
                            <Button
                              className={composeClassNames([sButton])}
                              size="lg"
                              variant="primary"
                              onClick={() => giftCardSubmit()}
                            >
                              <Translate tKey={`Send`} />
                            </Button>
                          </div>
                        ) : (
                          <PayuForm
                            clientCardNumber={userData.value.cardNo}
                            dOrder={dOrder}
                            gift={gift}
                            giftMessage={giftMessage}
                          />
                        )}
                      </Col>
                    </Row>
                  )}
                </Form>
              </Content>
            ) : (
              <EmptyBasket />
            )
          ) : (
            <Preloader />
          )
        ) : (
          <Preloader />
        )}

        <Footer />
      </Page>
      <Footers />
    </>
  );
}

export default Cart;
